import { useIdsSelect } from '@entities/common/IdsSelector/index.ts';

export const useOneVideoSelect = () => {
  return useIdsSelect('useOneVideoSelect')
}